import BaseComponent from '@js/BaseComponent'

/**
 * Controls filtering behavior for Writing archive list
 *
 * @extends BaseComponent
 */
class WritingListFilters extends BaseComponent {
    constructor(element) {
        super(element)

        if (sir.isEditor) return

        this.announcement = this.element.querySelector('.announcement')

        this.categorySelector = this.element.querySelector('.category-selector')

        this.list = document.querySelector(this.element.dataset.listSelector)

        this.categorySelector?.addEventListener('change', (event) => {
            this.element.dataset.categoryShow = event.target.value
            this.updateList()
            this.announceFilterChange()
        })

        this.announceFilterChange()
    }

    updateList() {
        this.list.dataset.categoryShow = this.categorySelector.value
    }

    announceFilterChange() {
        const visibleItems = [...this.list.querySelectorAll('article')]
            .filter(item => getComputedStyle(item).display !== 'none')
            .length

        const type = visibleItems === 1 ? 'article' : 'articles'

        this.announcement.innerHTML = `Showing ${visibleItems} ${type}`
    }
}

WritingListFilters.create('#writing-list-filters')
